import { FETCH_PROFILE } from '@/store/actions.type'
import vueAuthInstance from '@/services/auth'
import Papa from 'papaparse'
import { createPopup, createSidetab } from '@typeform/embed'
import Intercom from '@intercom/messenger-js-sdk'
import Clarity from '@microsoft/clarity'
import CryptoES from 'crypto-es'

const radEarth = 6378.16
const oneDegree = (2 * Math.PI * radEarth) / 360
const oneKm = 1 / oneDegree

export default {
  name: 'UtilsMixin',
  data() {
    return {
      theLogo: null,
      universe: {
        logo: '',
        logoLogin: ''
      }
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.profile && this.$store.getters.profile.id
    },
    hasCompany() {
      return this.$store.getters.profile.id && this.$store.getters.profile.company && this.$store.getters.profile.company.id !== null
    },
    hasMarketingSettings() {
      return this.$store.getters.profile && this.$store.getters.profile.company.marketing_settings.length !== 0 && this.$store.getters.profile.company.marketing_settings.findIndex(x => x.setting.type === 'industry') !== -1
    },
    isCompanyAdmin() {
      return this.hasCompany && this.$store.getters.profile.company && this.$store.getters.profile.roles.findIndex(x => x.name === 'company-admin' || x.name === 'self-service-admin') !== -1
    },
    hasMeliIntegration() {
      return this.$store.getters.profile && this.$store.getters.profile.platform_user_authorizations && this.$store.getters.profile.platform_user_authorizations.findIndex(x => x.platform.slug === 'meli') !== -1
    },
    hasFlex() {
      return this.$store.getters.hasFlex
    },
    isCompanyConfirmed() {
      return this.$store.getters.profile && this.$store.getters.profile.company && this.$store.getters.profile.company.status === 'confirmed'
    },
    isSelfService() {
      return this.$store.getters.profile && this.$store.getters.profile.company && this.$store.getters.profile.company.segment && this.$store.getters.profile.company.segment.name === 'SelfService'
    },
    profile() {
      return this.$store.getters.profile
    },
    cutTime() {
      let currentDay = this.moment.utc().tz(this.$tz).locale('en').format('dddd').toLowerCase()
      let type = currentDay !== 'sunday' && currentDay !== 'saturday' ? 'week' : currentDay
      return {
        time: this.$store.getters.profile.company['cut_time_' + type] || (type === 'week' ? window.countries.find(x => x.iso_code === this.$store.getters.profile.company.country_iso_code).cut_time : null),
        type: type,
        currentDay: currentDay
      }
    },
    courierI18n() {
      return this.$eid === 1 ? this.$gettext('Moover') : this.$gettext('Courier')
    },
    couriersI18n() {
      return this.$eid === 1 ? this.$gettext('Moovers') : this.$gettext('Couriers')
    },
    siteName() {
      return this.$store.getters.universe.siteName
    },
    helpEmail() {
      return this.$store.getters.universe.helpEmail || 'help@moova.io'
    },
    salesEmail() {
      return this.$store.getters.universe.salesEmail || 'help@moova.io'
    },
    integrationsEmail() {
      return this.$store.getters.universe.integrationsEmail || 'integrations@moova.io'
    }
  },
  methods: {
    async isAuth() {
      if (!this.$store.state.auth.uid) {
        let uid = vueAuthInstance.getPayload() ? vueAuthInstance.getPayload()['sub'] : null
        this.$store.commit('setUid', uid)
      }
      if (!this.$store.state.auth.email && this.$store.state.auth.isAuthenticated) {
        await this.$store.dispatch(FETCH_PROFILE)
          .then(response => {
            this.$store.commit('setEmail', this.$store.state.user.user.email)
            let payload = { profile: this.$store.state.user.user }
            this.$store.commit('setProfile', payload)
          })
      }
      return this.$store.state.auth.isAuthenticated
    },
    async init() {
      const isProd = process.env.ENV_FLAG === 'production'
      if (isProd) Clarity.init('ub4zq4gmu9')
      await this.isAuth().then(() => {
        if (this.$store.state.auth.isAuthenticated || this.isAuthenticated) {
          if (this.$store.getters.profile.id) {
            if (this.$eid === 1) {
              const intercomEnabledCountries = ['UY', 'PE']
              if (this.$store.getters.profile.company && intercomEnabledCountries.includes(this.$store.getters.profile.company.country_iso_code)) {
                this.fetchCompaniesSegments()
                  .then(() => {
                    const userId = `${this.$store.getters.profile.id}`
                    console.log(this.$store.getters.profile)
                    const hash = CryptoES.algo.HMAC.create(CryptoES.algo.SHA256, this.$appConfig.integrations.intercom.appId).update(userId).finalize().toString(CryptoES.enc.Hex)
                    if (isProd) {
                      Clarity.identify(this.$store.getters.profile.email)
                      Clarity.setTag('ecosystem', this.$ename)
                    }
                    Intercom({
                      app_id: 'xm93eaw3',
                      user_id: userId,
                      name: this.$store.getters.profile.name,
                      avatar: this.$store.getters.profile.profile_picture,
                      email: this.$store.getters.profile.email,
                      Pais: this.$store.getters.profile.company.country_iso_code,
                      company: {
                        id: `${this.$store.getters.profile.company.id}`,
                        name: this.$store.getters.profile.company.name,
                        Pais: this.$store.getters.profile.company.country_iso_code
                      },
                      user_hash: hash,
                      'Tipo de usuario': 'Seller'
                    })
                  })
              }
            }

            // $frontConfig, $universe, etc.
            this.$frontConfig = this.$store.getters.profile.company ? window.countries.find(x => x.iso_code === this.$store.getters.profile.company.country_iso_code).front_config : this.$frontConfig
            // Force meliApiVersion to 'flex' until API doesn't need it
            this.$frontConfig.meliApiVersion = 'flex'
            this.$frontConfig.i18n.tz = this.$tz = this.$cookies.get('bypassCountry') || !this.$frontConfig.i18n.tz ? 'UTC' : this.$frontConfig.i18n.tz
            this.$cookies.set('country', (this.$store.getters.profile.company ? this.$store.getters.profile.company.country_iso_code : window.country), 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
            this.$cookies.set('phonePrefix', this.$frontConfig.i18n.phonePrefix, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
            // this.$universe = this.$frontConfig.universe
            // this.$store.dispatch('setUniverse', this.$universe)
            this.checkFlex()

            if (this.$frontConfig.dashboardNps && this.$store.getters.profile && this.$store.getters.profile.company) {
              let cookieDate = new Date(this.moment().add(1, 'month').startOf('month').format('YYYY-MM-DD hh:mm:ss')).toUTCString()
              // NPS TypeForm popup
              if (this.$frontConfig.dashboardNps.popup && this.$frontConfig.dashboardNps.typeformId) {
                let typeformPopupOptions = {
                  container: document.getElementById('npsPopup'),
                  open: 'load',
                  hidden: {
                    empresa: this.$store.getters.profile.company.id
                  },
                  onReady: () => {
                    console.log('form ready')
                  },
                  onQuestionChanged: (data) => {
                    console.log('question changed to ref:', data.ref)
                  },
                  onSubmit: (data) => {
                    console.log('forms submitted with id:', data.responseId)
                    if (this.$frontConfig.dashboardNps.popup === 'until') {
                      this.$cookies.set('npsAnswered', true, cookieDate, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
                    }
                  }
                }
                if (this.$frontConfig.dashboardNps.popup === 'until' && !this.$cookies.get('npsAnswered')) {
                  createPopup(this.$frontConfig.dashboardNps.typeformId, typeformPopupOptions)
                } else if (this.$frontConfig.dashboardNps.popup === 'once' && !this.$cookies.get('npsShown')) {
                  this.$cookies.set('npsShown', true, cookieDate, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
                  createPopup(this.$frontConfig.dashboardNps.typeformId, typeformPopupOptions)
                }
              }
              // NPS TypeForm Sidetab
              if (this.$frontConfig.dashboardNps.sidetab && this.$frontConfig.dashboardNps.typeformId) {
                let typeformSidetabOptions = {
                  container: document.getElementById('npsSidetab'),
                  // open: 'load',
                  buttonText: this.$frontConfig.dashboardNps.text,
                  buttonColor: '#379CFB',
                  hidden: {
                    empresa: this.$store.getters.profile.company.id
                  },
                  onReady: () => {
                    console.log('form ready')
                  },
                  onQuestionChanged: (data) => {
                    console.log('question changed to ref:', data.ref)
                  },
                  onSubmit: (data) => {
                    console.log('forms submitted with id:', data.responseId)
                    if (this.$frontConfig.dashboardNps.sidetab === 'until') {
                      this.$cookies.set('npsAnswered', true, cookieDate, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
                    }
                  }
                }
                if (this.$frontConfig.dashboardNps.sidetab === 'until' && !this.$cookies.get('npsAnswered')) {
                  createSidetab(this.$frontConfig.dashboardNps.typeformId, typeformSidetabOptions)
                } else if (this.$frontConfig.dashboardNps.sidetab !== 'until') {
                  createSidetab(this.$frontConfig.dashboardNps.typeformId, typeformSidetabOptions)
                }
              }
            }
          } else {
            this.init()
          }
        }
      })
    },
    async checkFlex() {
      if (this.hasMeliIntegration) {
        await this.$http.get(this.$appConfig.api.baseUrl + 'platforms/meli/user-info')
          .then(response => {
            this.$store.dispatch('setMeliUser', response.body)
          })
        let payload
        if (!this.$frontConfig.meliApiVersion) {
          payload = {
            settings: {
              zones: {
                0: 'id',
                1: 'label',
                3: 'selected',
                price: {
                  0: 'cents',
                  1: 'fraction'
                }
              },
              cutoff: {
                selected: [
                  'week',
                  'saturday',
                  'sunday'
                ]
              },
              2: 'working_days'
            }
          }
        } else if (this.$frontConfig.meliApiVersion === 'flex') {
          payload = {
            settings: {
              0: 'working_days',
              zones: {
                0: 'id',
                1: 'label',
                2: 'selected',
                price: {
                  0: 'cents',
                  1: 'fraction'
                }
              },
              delivery_ranges: {
                week: {
                  0: 'calculated_cutoff'
                },
                saturday: {
                  0: 'calculated_cutoff'
                },
                sunday: {
                  0: 'calculated_cutoff'
                }
              },
              subscription: {
                0: 'site_id',
                1: 'user_id',
                2: 'service_id',
                3: 'creation_date',
                status: {
                  0: 'id'
                }
              }
            }
          }
        }
        await this.$http.post(this.$appConfig.api.baseUrl + 'platforms/meli/shippings/settings' + (!this.$frontConfig.meliApiVersion ? '' : '?meli_version=' + this.$frontConfig.meliApiVersion), payload)
          .then(response => {
            this.$store.dispatch('setHasFlex', true)
          }, () => {
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
          })
      }
    },
    randomInRange(from, to, fixed) {
      fixed = fixed || 10
      return (Math.random() * (to - from) + from).toFixed(fixed) * 1
    },
    jitterize(lat, lng, kms, fixed) {
      return {
        lat: this.randomInRange(
          lat - (kms * oneKm),
          lat + (kms * oneKm),
          fixed
        ),
        lng: this.randomInRange(
          lng - (kms * oneKm),
          lng + (kms * oneKm),
          fixed
        )
      }
    },
    /**
     * Copies to the Clipboard a string. Requires Toast to show copy result.
     * @param  {String} str         The string to copy to Clipboard
     * @param  {String} [type='id'] Optional. The element type you are copying to show the generic or specific result message
     * @param  {Boolean} [singleLine=false] Optional. If false it copies with new lines (adding one before the copied string)
     */
    copyToClipboard(str, type = 'id', singleLine = false) {
      let translated
      let selection
      let range
      const el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      if (!singleLine) {
        selection = document.getSelection()
        range = document.createRange()
      }
      try {
        if (!singleLine) {
          range.selectNode(el)
          selection.removeAllRanges()
          selection.addRange(range)
        }
        document.execCommand('copy')
        if (!singleLine) {
          selection.removeAllRanges()
        }
        let mssg
        switch (type) {
          case 'id':
            mssg = this.$gettext('The ID has been copied to Clipboard')
            break
          case 'email':
            mssg = this.$gettext('The e-mail has been copied to Clipboard')
            break
          case '':
            mssg = this.$gettext('The data has been copied to Clipboard')
            break
          default:
            translated = this.$gettext('The %{type} has been copied to Clipboard')
            mssg = this.$gettextInterpolate(translated, {type: type})
        }
        this.makeToast(this.$gettext('Notice'), mssg, 'success', false, 2000)
      } catch (e) {
        let mssg
        switch (type) {
          case 'id':
            mssg = this.$gettext('The ID could NOT be copied to Clipboard')
            break
          case 'email':
            mssg = this.$gettext('The e-mail could NOT be copied to Clipboard')
            break
          case '':
            mssg = this.$gettext('The data could NOT be copied to Clipboard')
            break
          default:
            translated = this.$gettext('The %{type} could NOT be copied to Clipboard')
            mssg = this.$gettextInterpolate(translated, {type: type})
        }
        this.makeToast(this.$gettext('Warning'), mssg, 'danger', false, 2000)
      }
      document.body.removeChild(el)
    },
    /**
     * Shows a Toast message on screen
     * @param  {String}  title                 The top title of the Toast box
     * @param  {String}  mssg                  The message to show
     * @param  {String}  [variant='info']      The Bootstrap variant for Toast colors
     * @param  {Boolean} [append=false]        Should be appended or prepended?
     * @param  {Number|False} [autoHideDelay=false] Time in ms before auto hide the Toast or false
     * @param  {Boolean} [solid=true]          Opacity style for the Toast
     */
    makeToast(title, mssg, variant = 'info', append = false, autoHideDelay = false, solid = true, toaster = 'b-toaster-top-right', id = undefined) {
      let options = {
        id: id,
        title: title,
        appendToast: append,
        variant: variant,
        solid: solid,
        toaster: toaster
      }
      if (autoHideDelay !== false) {
        options['autoHideDelay'] = autoHideDelay
      } else {
        options['noAutoHide'] = true
      }

      this.$bvToast.toast([mssg], options)
    },
    flattenObject(obj) {
      let toReturn = {}

      for (let i in obj) {
        if (!obj.hasOwnProperty(i)) continue

        if ((typeof obj[i]) === 'object' && obj[i] !== null) {
          let flatObject = this.flattenObject(obj[i])
          for (let x in flatObject) {
            if (!flatObject.hasOwnProperty(x)) continue

            toReturn[i + '.' + x] = flatObject[x]
          }
        } else {
          toReturn[i] = obj[i]
        }
      }
      return toReturn
    },
    unflattenObject(obj) {
      let result = {}
      for (let i in obj) {
        let keys = i.split('.')
        keys.reduce(function (r, e, j) {
          return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? obj[i] : {}) : [])
        }, result)
      }
      return result
    },
    stringToColour(str) {
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
      }
      let colour = '#'
      for (let n = 0; n < 3; n++) {
        let value = (hash >> (n * 8)) & 0xFF
        colour += ('00' + value.toString(16)).substr(-2)
      }
      return colour
    },
    textContrastColor(str) {
      let c = str.substring(1) // strip #
      let rgb = parseInt(c, 16) // convert rrggbb to decimal
      let r = (rgb >> 16) & 0xff // extract red
      let g = (rgb >> 8) & 0xff // extract green
      let b = (rgb >> 0) & 0xff // extract blue

      let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b // per ITU-R BT.709

      if (luma < 128) {
        return 'color: #fff'
      } else {
        return 'color: #000'
      }
    },
    toCsv(array) {
      return Papa.unparse(array)
    },
    /**
     * Auto download the data passed
     * @param  {Object} data Should contain the `data` itself, `type` and `filename` for the download
     * @param  {String}  data                  The data itself
     * @param  {String}  type                  The file type, ie.: text/csv
     * @param  {String}  filename              The name of the file to be downloaded
     */
    download(data, type, filename) {
      let blob = new Blob([data], { type: type })
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename)
      } else {
        let link = document.createElement('a')
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          let url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },
    optimalSize($dimensions) {
      console.log($dimensions)

      // 1. Find total volume
      let $volume = 0
      // 2. Find WHD ranges
      let $widthRange = []
      let $heightRange = []
      let $depthRange = []
      for (let i = 0; i < $dimensions.length; i++) {
        let [$width, $height, $depth] = $dimensions[i]
        $width = parseInt($width)
        $height = parseInt($height)
        $depth = parseInt($depth)

        $volume += $width * $height * $depth

        $widthRange.push($width)

        $heightRange.push($height)

        $depthRange.push($depth)
      }

      // 3. Order the WHD ranges
      $widthRange.sort((a, b) => a - b)
      $heightRange.sort((a, b) => a - b)
      $depthRange.sort((a, b) => a - b)

      // 4. Figure out every combination with WHD
      let $widthCombination = []
      let $heightCombination = []
      let $depthCombination = []

      $widthCombination = this.combination($widthRange)
      $heightCombination = this.combination($heightRange)
      $depthCombination = this.combination($depthRange)

      let $stacks = []
      let $rawStacks = []
      $widthCombination.forEach($width => {
        $heightCombination.forEach($height => {
          $depthCombination.forEach($depth => {
            let $v = $width * $height * $depth
            let $size = $width * $height * $depth // parseInt([$width, $height, $depth].sort((a, b) => b - a).join(''))

            if ($v >= $volume) {
              if ($stacks.findIndex(x => x.raw === $size) === -1) {
                $stacks.push({raw: $size, sizes: [$width, $height, $depth]})
              }
              if ($rawStacks.indexOf($size) === -1) {
                $rawStacks.push($size)
              }
            }
          })
        })
      })
      $stacks = [...new Set($stacks)].filter(Boolean).sort((a, b) => parseInt(a.raw) - parseInt(b.raw))
      return $stacks
    },
    combination($list) {
      let $combination = []
      let $total = Math.pow(2, $list.length)
      for (let $i = 0; $i < $total; $i++) {
        let $set = []
        // For each combination check if each bit is set
        for (let $j = 0; $j < $total; $j++) {
          // Is bit $j set in $i?
          if (Math.pow(2, $j) & $i) $set.push($list[$j])
        }

        if (!$set || $combination.indexOf($set.reduce(function (a, b) { return a + b }, 0)) !== -1) {
          continue
        }

        $combination.push($set.reduce(function (a, b) { return a + b }, 0))
      }

      $combination.sort((a, b) => a - b)

      return $combination
    },
    closeModal(modalRef) {
      this.$refs[modalRef].hide()
    },
    deepDiffMapper() {
      return {
        VALUE_CREATED: 'created',
        VALUE_UPDATED: 'updated',
        VALUE_DELETED: 'deleted',
        VALUE_UNCHANGED: 'unchanged',
        map: function (obj1, obj2) {
          if (this.isFunction(obj1) || this.isFunction(obj2)) {
            console.log('Invalid argument. Function given, object expected.')
          }
          if (this.isValue(obj1) || this.isValue(obj2)) {
            return {
              type: this.compareValues(obj1, obj2),
              data: obj1 === undefined ? obj2 : obj1
            }
          }

          let diff = {}
          for (let key in obj1) {
            if (this.isFunction(obj1[key])) {
              continue
            }

            let value2
            if (obj2[key] !== undefined) {
              value2 = obj2[key]
            }

            diff[key] = this.map(obj1[key], value2)
          }
          for (let key2 in obj2) {
            if (this.isFunction(obj2[key2]) || diff[key2] !== undefined) {
              continue
            }

            diff[key2] = this.map(undefined, obj2[key2])
          }

          return diff
        },
        compareValues: function (value1, value2) {
          if (value1 === value2) {
            return this.VALUE_UNCHANGED
          }
          if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
            return this.VALUE_UNCHANGED
          }
          if (value1 === undefined) {
            return this.VALUE_CREATED
          }
          if (value2 === undefined) {
            return this.VALUE_DELETED
          }
          return this.VALUE_UPDATED
        },
        fieldsToUpdate: function (newObj, originalObj) {
          let updatedFields = this.map(newObj, originalObj)
          Object.keys(updatedFields).forEach(key => {
            if (updatedFields[key].type !== this.VALUE_UPDATED) {
              delete updatedFields[key]
            } else {
              updatedFields[key] = updatedFields[key].data
            }
          })
          return updatedFields
        },
        isFunction: function (x) {
          return Object.prototype.toString.call(x) === '[object Function]'
        },
        isArray: function (x) {
          return Object.prototype.toString.call(x) === '[object Array]'
        },
        isDate: function (x) {
          return Object.prototype.toString.call(x) === '[object Date]'
        },
        isObject: function (x) {
          return Object.prototype.toString.call(x) === '[object Object]'
        },
        isValue: function (x) {
          return !this.isObject(x) && !this.isArray(x)
        }
      }
    },
    openMapOn(placeString) {
      window.open('https://www.google.com/maps/place/' + placeString.replace(/\+/g, '%2B'))
    },
    setLocalStorage(key, value) {
      if (typeof value === 'object') {
        value = JSON.stringify(value)
      }
      localStorage[key] = value
    },
    getLocalStorage(key) {
      try {
        return JSON.parse(localStorage[key])
      } catch (e) {
        return localStorage[key]
      }
    }
  }
}
